import React,{useState,useEffect} from 'react'
import Input from '../../../../components/panelcontrols/panelinput'
import Button from '../../../../components/panelcontrols/panelbuttonmain'
import Button2 from '../../../../components/panelcontrols/panelbuttonsecond'
import Functions from '../functions'
import { PERMISSION_GROUPS } from '../../../../configTools/permissions'
// The overlay/close-button shell is the edit modal's. Imported explicitly rather than relying
// on that file happening to be loaded elsewhere on the page, and rather than duplicating 30
// lines of CSS that would then drift.
import '../edit/index.css'
import './index.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

// Gives one employee a login and picks which pages it can reach.
//
// The permission list here is only what the UI offers - the API enforces the same keys on
// every request, so unticking a box is a real revocation rather than just a hidden menu item.
const Index = ({selectedEmployee,setSelectedEmployee,toast,setList,setShowAccess}) => {
    const [loading,setLoading] = useState(true);
    const [hasLogin,setHasLogin] = useState(false);
    const [username,setUsername] = useState('');
    const [password,setPassword] = useState('');
    const [granted,setGranted] = useState([]);

    useEffect(()=>{
        if(!selectedEmployee){ return; }
        setLoading(true);
        Functions.GetAccess(selectedEmployee.id,(access)=>{
            if(access){
                setHasLogin(access.hasLogin);
                setUsername(access.username || '');
                setGranted(Array.isArray(access.permissions) ? access.permissions : []);
            }
            // Never prefilled, for an existing login or a new one - the server only stores a
            // bcrypt hash, so there is nothing to show, and blank means "keep the current one".
            setPassword('');
            setLoading(false);
        });
    },[selectedEmployee])

    const reset = ()=>{
        setSelectedEmployee(null);
        setShowAccess(false);
    }

    const toggle = (key)=>{
        setGranted((current)=> current.indexOf(key) === -1
            ? [...current, key]
            : current.filter((k)=> k !== key));
    }

    const toggleGroup = (items)=>{
        const keys = items.map((i)=>i.key);
        const allOn = keys.every((k)=> granted.indexOf(k) !== -1);
        setGranted((current)=> allOn
            ? current.filter((k)=> keys.indexOf(k) === -1)
            : [...current, ...keys.filter((k)=> current.indexOf(k) === -1)]);
    }

  return (
    <div className='labadmin_product_edit_wrapper'>
        <div className='labadmin_product_edit_container'>
            <div className='labadmin_product_edit_close'>
                <button onClick={reset}>
                    <FontAwesomeIcon icon={faXmark}/>
                </button>
            </div>
            <div className='labadmin_product_formbox'>
                <h3>Login &amp; Access{selectedEmployee ? ' — ' + selectedEmployee.name : ''}</h3>
                {loading &&
                    <p className='labadmin_access_hint'>Loading…</p>
                }
                {!loading &&
                    <>
                        <div className='labadmin_employee_row'>
                            <div className='labadmin_employee_col50'>
                                <Input Lable={'Username'} Type={'text'} Value={username} setValue={setUsername}/>
                            </div>
                            <div className='labadmin_employee_col50'>
                                <Input
                                    Lable={hasLogin ? 'New password (leave blank to keep current)' : 'Password'}
                                    Type={'password'} Value={password} setValue={setPassword}/>
                            </div>
                        </div>

                        <p className='labadmin_access_hint'>
                            Tick the pages this employee may open. Anything unticked is blocked on the
                            server as well as hidden from their sidebar.
                        </p>

                        <div className='labadmin_access_groups'>
                            {PERMISSION_GROUPS.map((group)=>{
                                const keys = group.items.map((i)=>i.key);
                                const allOn = keys.every((k)=> granted.indexOf(k) !== -1);
                                return (
                                    <div className='labadmin_access_group' key={group.group}>
                                        <div className='labadmin_access_group_head'>
                                            <span>{group.group}</span>
                                            <button type='button' onClick={()=>toggleGroup(group.items)}>
                                                {allOn ? 'Clear' : 'Select all'}
                                            </button>
                                        </div>
                                        {group.items.map((item)=>(
                                            <label className='labadmin_access_item' key={item.key}>
                                                <input
                                                    type='checkbox'
                                                    checked={granted.indexOf(item.key) !== -1}
                                                    onChange={()=>toggle(item.key)}/>
                                                <span>{item.label}</span>
                                            </label>
                                        ))}
                                    </div>
                                );
                            })}
                        </div>

                        <div className='labadmin_employee_row'>
                            <div className='labadmin_employee_col50'>
                                <Button Value={hasLogin ? 'Save access' : 'Create login'} Action={()=>{
                                    const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
                                    if(username.trim() === ''){
                                        toast.update(toastid, { render: "Username is required", type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
                                        return;
                                    }
                                    if(!hasLogin && password === ''){
                                        toast.update(toastid, { render: "A password is required for a new login", type: "error", isLoading: false, autoClose:2500, position: toast.POSITION.BOTTOM_CENTER });
                                        return;
                                    }
                                    // Saving with nothing ticked is allowed - it is how you suspend
                                    // someone without deleting their account - but it is worth a
                                    // confirmation, since the result is a login that can reach nothing.
                                    if(granted.length === 0){
                                        toast.dismiss(toastid);
                                        if(!window.confirm('No pages are ticked. This employee will be able to log in but see nothing. Continue?')){
                                            return;
                                        }
                                    }
                                    Functions.SetAccess(selectedEmployee.id,{
                                        username: username.trim(),
                                        password: password,
                                        permissions: granted
                                    },setList,toast,toastid,reset);
                                }}/>
                            </div>
                            <div className='labadmin_employee_col50'>
                                {hasLogin &&
                                    <Button2 Value={'Remove login'} Action={()=>{
                                        if(!window.confirm('Remove this login? The employee record stays, but they will no longer be able to sign in.')){
                                            return;
                                        }
                                        const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
                                        Functions.RemoveAccess(selectedEmployee.id,setList,toast,toastid,reset);
                                    }}/>
                                }
                            </div>
                        </div>
                    </>
                }
            </div>
        </div>
    </div>
  )
}

export default Index
